module.exports = __webpack_public_path__ + "fonts/d687b55c234963880ef732ab1eabbb01-Roboto-ThinItalic.ttf";